import { render, staticRenderFns } from "./CaracteristicasEstatisticas.vue?vue&type=template&id=f74c3c34"
import script from "./CaracteristicasEstatisticas.vue?vue&type=script&lang=js"
export * from "./CaracteristicasEstatisticas.vue?vue&type=script&lang=js"
import style0 from "./CaracteristicasEstatisticas.vue?vue&type=style&index=0&id=f74c3c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports